let accessToken;
let accessTokenExpiry;
// Client ID from Spotify API.
const clientID = 'b8e2733658324e17bd1ec9d04db91b7f';
// Redirect URL for Spotify API.
const redirectUrl = 'https://gleeful-cendol-18e226.netlify.app/';

const Spotify = {
    // Get the access token from Spotify API.
    getAccessToken() {
        return new Promise((resolve, reject) => {
          if (accessToken && Date.now() < accessTokenExpiry) {
            resolve(accessToken);
          } else {
            const accessTokenMatch = window.location.href.match(/access_token=([^&]*)/);
            const expiresInMatch = window.location.href.match(/expires_in=([^&]*)/);
    
            if (accessTokenMatch && expiresInMatch) {
              accessToken = accessTokenMatch[1];
              const expiresIn = Number(expiresInMatch[1]);
              accessTokenExpiry = Date.now() + expiresIn * 1000;
              window.history.pushState('Access Token', null, '/');
              resolve(accessToken);
            } else {
              window.location = `https://accounts.spotify.com/authorize?client_id=${clientID}&response_type=token&scope=playlist-modify-public&redirect_uri=${redirectUrl}`;
            }
          }
        });
      },

    // Search for songs in the Spotify API.
    async search(term) {
        // Get the access token.
        accessToken = await this.getAccessToken();

        const response = await fetch(`https://api.spotify.com/v1/search?type=track&q=${term}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${accessToken}` },
        });
        const jsonResponse = await response.json();
        if (!jsonResponse.tracks) {
            alert('Response Error');
        }
        console.log(accessToken);
        return jsonResponse.tracks.items.map(track => {
            return {
                id: track.id,
                name: track.name,
                artist: track.artists[0].name,
                album: track.album.name,
                uri: track.uri
            };
        });
    },

    async savePlaylist(name, trackURIs) {
        if (!trackURIs.length) {
          alert('Please add some tracks to your playlist.');
          return;
        }
        // Await the access token
        accessToken = await this.getAccessToken();
        const response = await fetch('https://api.spotify.com/v1/me', {
          method: 'GET',
          headers: { Authorization: `Bearer ${accessToken}` },
        });
        const data = await response.json();
        const userID = data.id;
    
        const responseCreatePlaylist = await fetch(`https://api.spotify.com/v1/users/${userID}/playlists`, {
            method: 'POST',
            headers: { 
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ name: name }),
          });
          const dataPlaylist = await responseCreatePlaylist.json();
          const playlistId = dataPlaylist.id;
    
          await fetch(`https://api.spotify.com/v1/playlists/${playlistId}/tracks`, {
            method: 'POST',
            headers: { 
              Authorization: `Bearer ${accessToken}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ uris: trackURIs }),
          });
    
          alert('Playlist saved to Spotify!');
      }
        
}

export default Spotify;